import React from "react";
import "./loading.css";
import loading from "../../../assets/images/loading.svg";

interface ILoadingProps {
    show?: boolean,
    absolute?: boolean,
    bgShow?: boolean,
}

const Loading: React.FC<ILoadingProps> = ({show = false, absolute, bgShow = false}) => {
    return (
        <div
            className={`loading ${absolute ? "loading-absolute" : null} ${bgShow ? "bg-show" : null} animate__animated ${!show ? "animate__fadeOut" : ""}`}>
            <img src={loading} alt="loading..."/>
        </div>
    )
}

export default Loading;